import theme from '../../../lib/theme';

const {
  corners,
  inputReset,
  scale,
  colors,
  layers,
  font: {
    heights,
    spacings,
    families,

    ...font
  },
} = theme;

export default () => ({
  searchResults: {
    position: 'absolute',
    background: '#FFFFFF',
    borderTop: 'transparent 10px solid',
    boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
    padding: '0.5rem 1rem',
    overflowY: 'scroll',
  },
  resultsHeading: {
    color: colors.sas.primary,
    fontWeight: 'bold',
    marginTop: '10px',
    marginBottom: '10px',
    paddingLeft: '1rem',
  },
  searchPanel: {
    position: 'relative',
    zIndex: layers.highest,
    width: '100%',
    height: '100%',
  },
  searchBox: {
    border: 'none',
    borderRadius: '40px',
    outline: 'none',
    paddingTop: '3px',
    paddingBottom: '3px',
    paddingLeft: '10px',
    paddingRight: '10px',
    width: '100%',
    position: 'relative',
    height: '100%',
    color: 'black',
  },
  searchButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    color: colors.sas.primary,
    background: colors.sas.secondary,
    borderRadius: '20px',
    fontSize: '14px',
    paddingLeft: '10px',
    paddingRight: '10px',
    height: '100%',
    alignItems: 'center',
    display: 'flex',
    fontWeight: 'bold',
  },
  resultContainer: {
    listStyle: 'none',
    paddingLeft: 0,
  },
  resultItemContainer: {
    padding: '0.5rem 1rem',
    '&&&:hover': {
      background: 'rgba(101, 31, 255, 0.1)',
    },
  },
  resultItem: {
    color: '#263238!important',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  resultImage: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    marginRight: '1rem',
  },
  button: {
    borderColor: `${colors.travel360.primary} !important`,
    backgroundColor: `${colors.travel360.primary} !important`,
    padding: '0.3rem 1rem !important',

    '&:hover': {
      color: `${colors.white} !important`,
      borderColor: `${colors.travel360.primary} !important`,
      backgroundColor: `${colors.travel360.primary} !important`,
    },
  },
});
